export default __webpack_public_path__ + "static/media/high-res-logo-p-800.7f8c7a1a.png";